/**
 * Predefined addresses for prescription ingestion
 * Used across multiple workflows for patient address selection
 */

export interface Address {
    stateName: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    zipCode: string;
}

export const PREDEFINED_ADDRESSES: Address[] = [
    {
        stateName: "WA",
        addressLine1: "7803 SE 27th St",
        addressLine2: "APT D400",
        city: "Mercer Island",
        zipCode: "98040",
    },
    {
        stateName: "CA",
        addressLine1: "475 Sansome Street",
        addressLine2: "10th Floor",
        city: "San Francisco",
        zipCode: "94111",
    },
];
